import React, { useState, useRef, useEffect } from "react";
import DropdownMenu from "~/Common-Objects/UI/DropdownMenu";
import Icon from "~/Common-Objects/UI/Icon";
import SmileyPicker from "~/Common-Objects/UI/Forms/TextInput/smileyPicker";
import InboxButton from "../../shared/inboxButton";
import i18n from "~/i18n";

export default function SmileyPickerTool({ userRole = 0, onSelect = () => { } }) {

  const [pickerOpen, setPickerOpen] = useState(false);

  useEffect(() => {
    setPickerOpen(false);
  }, []);


  const selectSmiley = (smiley) => {
    setPickerOpen(false);
    onSelect(smiley);
  }


  return (
    <>
      <DropdownMenu.Root open={pickerOpen} onOpenChange={(e) => { setPickerOpen(e) }}>
        <DropdownMenu.Trigger asChild>
          <InboxButton
            variant="ghost"
            size="s"
            iconOnly
            aria-label="Insert Emoji"
            data-tooltip-content={i18n.t("chat:inbox.conversation.composer.insertEmoji")} data-tooltip-id="emoji"
            disabled={userRole > 1}
          >
            <Icon name="emoji-smile" style={{ width: 20, height: 20 }} />
          </InboxButton>

        </DropdownMenu.Trigger>

        <DropdownMenu.Portal >
          <DropdownMenu.Content align="start" className="conversations_composer_smileyPicker_popup">
            <SmileyPicker onPick={selectSmiley} />
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root >

    </>

  );
}

